export const ROOT_ELEMENT = document.querySelector('[data-role="root"]');
export const SCROLL_ELEMENT = document.body;
export const ROOT_CLASS = 'application';
export const DOCUMENT_ELEMENT = document.documentElement;
export const SCROLLBAR_PADDING_SELECTORS = ['body', 'header'];



// WEBPACK FOOTER //
// ./scripts/constants.js